/*

ashraf   10/16/2022  2700632669  added code comments in search, add user management.
Akhlaque 10/26/2022  2700632669   renamed clear button to reset
prakash 26/10/2022 2700632669 added classes for text-fields and buttons.
Rohini 28/10/2022 2700632669 added grid in the search user
Lalitha 10/26/2022  2700632669  renamed clear button to reset
Ashraf 10/30/2022  2700632669 fixed spell mistake of company code
Raghu 11/03/2022  2700632669 Responsive Alignment Fixes
Ashraf 12/07/2022  2700632669 fixed user login name field
Ashraf 12/07/2022  2700632669 added login user name field
Akhila 12/08/2022 2700632669 added session storage for search items
lalitha 12/12/2022 2700632669 added status dropdown
Raghu 14/12/2022 2700632669 Field alignment issues
Prakash 12/22/2022 2700632669 Removed Card Component.
Suresh Peddavoora 12/23/2022 2700632669 Fixed Multi Select Dropdown Alignment issue
Raghu 12/30/2022 2700632669 fixed alignment in company code.
Dilip 01/05/2023  2700632669 fixed dropdown issues
suresh peddavoora 02/24/2023 2700632669 New UI changes added
suresh peddavoora 02/27/2023 2700632669 New UI changes
suresh peddavoora 03/03/2023 2700632669 Tables and fields alignments
suresh peddavoora 03/14/2023 2700632669 Tables and fields alignments
Rohini 03/21/2023 2700632669 Added classname for button alignments in responsive.
suresh peddavoora 03/06/2023 2700632669 fields alignments
Ravi  05/04/2023 2700632669 changed status bydefault to Active
AKhila 06/08/2023 2700632669 re arrange the search screen with table column
Sohel 10/26/2023 2700632669 saerch screen UI and payload changes
Sohel 12/07/2023 2700632669 Adding unlock user status and payload changes

*/

import {
  Grid,
  Button,
  TextField,
  Checkbox,
  FormHelperText,
} from '@material-ui/core';
import {Form, Formik} from 'formik';
import {useSelector} from 'react-redux';
import React, {useState, useEffect, useContext} from 'react';
import ErrorBoundaryForComponents from '../../../util/ErrorBoundaryForComponents';
import UserManagementTable from './UserManagementTable';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {useDispatch} from 'react-redux';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import {getOptions} from '../../../util/GetDropDownOptions';
import {COMPANY_TYPE} from '../../../constants/Lookup';
// import {ResetData} from '../../../redux/reducers/UserManagement/AddUser';
import {getCompanyCode} from '../../../redux/reducers/LetterMaintainance/AddLetterData';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import {getAllReportCreatedForData} from '../../../redux/reducers/ReportMaster';
import {PhoneMaskCustom} from '../../../util/PhoneMaskFormat';
import * as Yup from 'yup';
import {ResetData as resetData} from '../../../redux/reducers/UserManagement/AddUser';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;

// search user form, existing users table component render (2700632669)
const SearchUserManagement = ({
  setValue,
  setRecordFormatCode,
  selected,
  setSelected,
  setCompanyCode,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();

  const searchSessionUserManagement = JSON.parse(sessionStorage.getItem('searchUserManagement'));

  // initial values for search form (2700632669)
  const initialValues = {
    userName: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    emailId: '',
    companyCode: [],
    roles: '',
    location: '',
    // userLoginName: "",
    departmentDivision: '',
    isActive: {key: 'Y', value: 'Active'},
  };

  const {companyCodeData} = useSelector(({addLetterData}) => addLetterData);
  const [submit, setSubmit] = useState(false);
  const [searchData, setSearchData] = useState(false);
  const StatusOptions = [
    {key: 'A', value: 'All'},
    {key: 'Y', value: 'Active'},
    {key: 'N', value: 'InActive'},
    {key: 'locked', value: 'Locked'},

  ];
  const validationSchema = Yup.object().shape({
    phoneNumber: Yup.string()
      .nullable()
      .test('phoneNumber', 'Invalid phone number', (value) => {
        value = value && value.replace(/[^\d]/g, '');
        if ((value && /^(\d)(?!\1+$)\d{9}$/.test(value)) || !value) {
          return true;
        }
      }),
  });
  // search data submission (2700632669)
  const handleSubmit = (data) => {
    setSubmit(true);
    setSearchData(data);
    sessionStorage.setItem('searchUserManagement', JSON.stringify(data));
  };

  // fetch company code field dropdown data, resetting states back to null (2700632669)
  useEffect(() => {
    dispatch(getCompanyCode());
    dispatch(resetData());
    setSelected('');
    setCompanyCode([]);
    dispatch(getAllReportCreatedForData());
  }, []);

  return (
    <div>
      <h2 className="search-title">User Management Search</h2>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={searchSessionUserManagement ? searchSessionUserManagement : initialValues}
        enableReinitialize
        validationSchema={validationSchema}
      >
        {(props) => {
          const {values, handleChange, handleReset, handleBlur, setFieldValue, errors} = props;
          return (
            <div>
              <Form autoComplete="off">
                <div className="global-field-textfields new-standard-textfields">
                  <ErrorBoundaryForComponents>
                    <Grid container spacing={2}>
                      <>
                        <Grid item xs={6} sm={6} lg={3} md={3} className="form-group">
                          <TextField
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter User Login Name`}
                            label="User Login Name"
                            className={` ${classes.labelName}`}
                            name="userName"
                            value={values.userName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        {/* <Grid item xs={6} sm={6} lg={3} md={3} className="form-group">
                          <TextField
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter User Name`}
                            label="User Name"
                            className={` ${classes.labelName}`}
                            name="userLoginName"
                            value={values.userLoginName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid> */}
                        <Grid item xs={6} sm={6} lg={3} md={3} className="form-group">
                          <TextField
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter First Name`}
                            label="First Name"
                            className={` ${classes.labelName}`}
                            name="firstName"
                            value={values.firstName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} lg={3} md={3} className="form-group">
                          <TextField
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Last Name`}
                            label="Last Name"
                            className={` ${classes.labelName}`}
                            name="lastName"
                            value={values.lastName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} lg={3} md={3} className="form-group">
                          <TextField
                            className={`${classes.labelName}`}
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Phone Number`}
                            label="Phone Number"
                            name="phoneNumber"
                            value={values?.phoneNumber}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            InputProps={{
                              inputComponent: PhoneMaskCustom,
                            }}
                            fullWidth
                            error={Boolean(errors.phoneNumber)}
                          />
                          <FormHelperText variant="outlined">
                            {errors.phoneNumber ? errors.phoneNumber : ''}
                          </FormHelperText>
                        </Grid>
                        <Grid item xs={6} sm={6} lg={3} md={3} className="form-group">
                          <TextField
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Email-Id`}
                            label="Email Id"
                            className={` ${classes.labelName}`}
                            name="emailId"
                            value={values.emailId}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} lg={3} md={3} className="form-group">
                          <TextField
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Roles`}
                            label="Roles"
                            className={` ${classes.labelName}`}
                            name="roles"
                            value={values.roles}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          sm={6}
                          md={6}
                          lg={3}
                          xl={3}
                          className={`form-group autocomplete-field ${
                            values.companyCode.length > 3 && `autocomplete-checkbox`
                          }`}
                        >
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                              popper: classes.popper,
                            }}
                            className={` ${classes.labelName}`}
                            disableCloseOnSelect
                            limitTags={1}
                            name="companyCode"
                            multiple
                            id="companyCode"
                            size="small"
                            value={values.companyCode}
                            options={getOptions(COMPANY_TYPE, companyCodeData)}
                            // getOptionDisabled={(option) => option.key === null}
                            getOptionSelected={(option, value) => option.value === value.value}
                            getOptionLabel={(option) => {
                              return option && option.value ? option.value : '';
                            }}
                            onChange={(e, value) => {
                              setFieldValue('companyCode', value);
                            }}
                            placeholder="Select Company Code"
                            renderOption={(option, {selected}) => (
                              <React.Fragment>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={
                                    <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                                  }
                                  checked={selected}
                                  className={classes.checkBox}
                                />

                                {option?.value ? option.value : ''}
                              </React.Fragment>
                            )}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  variant="outlined"
                                  margin="dense"
                                  className="autocomplete-multiselect-label"
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'off', // disable autocomplete and autofill
                                  }}
                                  label="Company Code"
                                  placeholder="Select Company Code"
                                />
                              </div>
                            )}
                          />
                        </Grid>

                        <Grid item xs={6} sm={6} md={3} lg={3} xl={3} className="form-group">
                          <TextField
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Location`}
                            label="Location"
                            className={` ${classes.labelName}`}
                            name="location"
                            value={values.location}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={6} md={3} lg={3} xl={3} className="form-group">
                          <GuiAutoComplete
                            classes={{
                              popper: classes.popper,
                              option: classes.option,
                            }}
                            name="isActive"
                            id="isActive"
                            size="small"
                            options={StatusOptions}
                            required
                            value={values.isActive}
                            getOptionLabel={(option) => {
                              return option && option?.value;
                            }}
                            onChange={(e, value) => {
                              handleChange(e);
                              setFieldValue('isActive', value);
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  className={` ${classes.labelName}`}
                                  variant="outlined"
                                  margin="dense"
                                  // InputLabelProps={{ shrink: true }}
                                  label="Status"
                                  placeholder="Select Status"
                                />
                              </div>
                            )}
                          />
                        </Grid>

                        {/* <Grid item xs={2} xl={1}>
                          <FormControl margin="dense">
                            <FormControlLabel
                              className={classes.checkRoot}
                              control={
                                <Checkbox
                                  onChange={handleChange} // for future use
                                  name="active"
                                  checked={values.active}
                                  color="primary"
                                />
                              }
                              label="Active"
                              labelPlacement="end"
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={4} xl={2}>
                          <FormControl margin="dense">
                            <FormControlLabel
                              className={classes.checkRoot}
                              control={
                                <Checkbox
                                  onChange={handleChange} // for future use
                                  name="inActive"
                                  checked={values.inActive}
                                  color="primary"
                                />
                              }
                              label="In Active"
                              labelPlacement="end"
                            />
                          </FormControl>
                        </Grid> */}

                        <Grid item xs={3} md={12} lg={3} xl={3}>
                          <div className="d-flex align-items-start justify-content-lg-start justify-content-md-center mb-3">
                            <Button
                              variant="outlined"
                              className={`mr-1 ${classes.buttonRoot} reset-btn`}
                              onClick={() => {
                                handleReset();
                                setSearchData(initialValues);
                                sessionStorage.removeItem('searchUserManagement');
                              }}
                            >
                              Reset
                            </Button>
                            <Button
                              type="submit"
                              variant="outlined"
                              className={`ml-1 ${classes.buttonRoot} search-btn`}
                            >
                              Search
                            </Button>
                          </div>
                        </Grid>
                      </>
                    </Grid>
                  </ErrorBoundaryForComponents>
                </div>
              </Form>
              {/* {isLoading && <PageLoader />} */}
            </div>
          );
        }}
      </Formik>
      <Grid>
        <UserManagementTable
          submit={submit}
          searchData={searchData}
          setSubmit={setSubmit}
          setValue={setValue}
          setSelected={setSelected}
          selected={selected}
          setCompanyCode={setCompanyCode}
        />
      </Grid>
    </div>
  );
};

export default SearchUserManagement;
